import React, { useState } from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import HeroSection from '../../common/HeroSection/HeroSection';
import getIcons from '../../functions/getIcons/getIcons';
import ThemeNineTitle from '../common/ThemeNineTitle';

const data = [
  {
    title: '¿Qué es Tarjeta Viajero Frecuente?',
    des: `<p>El programa viajero frecuente es un beneficio para nuestros clientes para que se hagan socios de <span class="bold-text">Buses Fernández Ltda.,</span> el que les permite acumular kilómetros en una cuenta personal, los que se podrán canjear por pasajes en el tramo <span class="bold-text">PUNTA ARENAS – PUERTO NATALES</span> o viceversa.</p>
      <p>Adicional a lo anterior, le permite acceder a una tarifa preferencial en pasajes en el tramo <span class="bold">PUNTA ARENAS – PUERTO NATALES</span> o viceversa.</p>
      <p>Participas en sorteos programados periódicamente, que le permitirán acceder a los premios definidos para estos.</p>
      `,
    img:
      '/assets/fernandez/FT/BusesFernandez-Website-FrequentTraveler-FrequentTravelerCard-CardImage.png',
    active: true,
  },

  {
    title: '¿Cómo inscribirme?',
    des: `
      <p>Tiene que dirigirse a nuestros puntos de ventas de pasajes, tanto en Punta Arenas como Puerto Natales y completar el formulario respectivo. <br> No olvide portar su cédula de Identidad.</p>
      <p>También nos puede solicitar su inscripción a través de la página web en la sección contacto; ahí nos envía un mensaje con sus datos y nosotros lo contactaremos para gestionar el formulario respectivo.</p>
      `,

    active: false,
  },

  {
    title: '¿Cuál es el costo de la tarjeta?',
    des: `
            <p>Para acceder a la tarjeta de Viajero Frecuente, deberá cancelar por única vez el monto de $3.000.- (tres mil pesos).</p>
            <p>Si necesita reimprimir la tarjeta como consecuencia de la pérdida de ésta, se aplicará nuevamente dicho costo.</p>
      `,
    active: false,
  },

  {
    title: '¿Cómo compro pasajes?',
    des: `<p>De manera presencial: en cualquiera de nuestros puntos de ventas de pasajes, presentando tu <span class="bold">TARJETA DE VIAJERO FRECUENTE</span> y su cédula de Identidad.</p>`,
    active: false,
  },

  {
    title: '¿Cómo acumulo kilómetros?',
    des: `
            <p>-Al inscribirse como <span class="bold">VIAJERO FRECUENTE,</span> obtendrá inmediatamente 250 kilómetros, los que serán abonados a su cuenta personal.</p>
            <p>-Por la compra de pasajes en el tramo <span class="bold">PUNTA ARENAS – PUERTO NATALES</span> o viceversa obtendrá 250 kilómetros.</p>
            <p>-El día de su cumpleaños abonaremos 250 kilómetros a su cuenta.</p>
          `,
    active: false,
  },

  {
    title: '¿Cómo canjeo mis kilómetros?',
    des: `
            <p>Por cada 12.000 (doce mil) kilómetros acumulados en su cuenta personal, podrá canjear 01 (un) pasaje para el tramo <span>PUNTA ARENAS – PUERTO NATALES</span> o viceversa.</p>
            <p>Los tramos intermedios no aplican para este beneficio, es decir, no se puede canjear pasajes ni tampoco acumular puntos.</p>
            <p>Para realizar el canje se debe presentar en nuestros puntos de ventas de pasajes con su <span class="bold">TARJETA DE VIAJERO FRECUENTE</span> y su cédula de identidad.</p>
            <p>Si necesita que otra persona realice el canje por usted, entonces deberá presentar un poder notarial que lo individualice como socio e identifique a la persona que autorizará para hacer dicha gestión.</p>
    `,
    active: false,
  },
];

const ThemeNineRegulationTnCScreen = props => {
  const [state, setState] = useState(data);
  const [selected, setSelected] = useState(state[0]);

  const handleSubmit = item => {
    const newState = state.map(d => {
      d.active = d.title === item.title ? true : false;
      return d;
    });
    setState(newState);
    setSelected(item);
  };

  const createMarkup = data => {
    return {
      __html: data,
    };
  };

  return props.home.operator ? (
    <div className="themes-theme-nine-regulation-tnc-screen">
      <KuposHelmet />

      <div style={{ position: 'relative' , marginTop: -20}}>
        <HeroSection
          // height={'30vh'}
          heroImage={getIcons('tncRegulationBanner')}
          title={'Reglamento'}
          description={'Home / Términos y condiciones / Reglamento'}
        />
      </div>

      <ThemeNineTitle title={'Reglamento de servicios internacionales'} />

      <div className="regulation-container">
        <div className="regulation-terms">
          <p>
            La Empresa se reserva el derecho de alterar, total o parcialmente el itinerario y los
            días y horarios de salida entre Chile y Argentina (y viceversa), en el caso que por
            razones climáticas NO SE PUEDA CRUZAR LA CORDILLERA DE LOS ANDES, debido a obstrucción
            del camino, por la acumulacion de nieve, temporales u otros inconvenientes ajenos a la
            voluntad de la Empresa.<br></br>
            Por lo tanto el pasajero, deberá atenerse a las determinaciones que la Empresa tome al
            respecto.<br></br> Los gastos que pudieren ocasionar al pasajero, los imprevistos
            citados, quedarán absolutamente a cargo de él mismo. Tales gastos no serán
            responsabilidad de la Empresa.<br></br>
            La empresa no se responsabiliza por ATRASOS que se originen en virtud de los imprevistos
            mencionados.
          </p>

          <p className="bold-text">
            Al momento de la compra es obligación del cliente presentar sus documentos como el rut o
            pasaporte al día, de lo contrario no se podrá emitir el pasaje, si viajan menores de
            edad también es obligación presentar libreta de familia, rut, y permisos notariales
            (ocupen asiento o no).
          </p>

          <p>
            <span class="bold-orange">1.- </span>El Boleto es personal e intransferible, válido para
            hora y día indicado.
          </p>

          <p>
            <span class="bold-orange">2.- </span>El pasajero tiene derecho a 20 kilos de equipaje y
            el exceso será admitido siempre que la capacidad del Bus lo permita habiendo pagado
            dicho exceso.
          </p>

          <p>
            <span class="bold-orange">3.- </span> La empresa no asume responsabilidad alguna por
            equipaje que conduzca el propio pasajero, y que no estén etiquetadas por comprobantes
            propios de la Empresa.
          </p>

          <p>
            <span class="bold-orange">4.- </span> La Empresa no proporciona movilización a los
            pasajeros, de ninguno de sus terminales, el pasajero deberá presentarse para su viaje
            con media hora de anticipación, a la indicada en su pasaje.
          </p>

          <p>
            <span class="bold-orange">5.- </span> La Empresa no se hace responsable por daños o
            pérdidas en el equipaje de propiedad personal del pasajero. Salvo que haya declarado el
            valor de tales efectos.
          </p>

          <p>
            <span class="bold-orange">6.- </span> Si por cualquier motivo el Bus atrasa su salida en
            cualquier punto o demora su llegada en cualquier punto, de acuerdo con cualquier
            itinerario, la Empresa no será responsable de daños o perjuicios que estas demoras le
            puedan ocasionar al pasajero.
          </p>

          <p>
            <span class="bold-orange">7.- </span> La Empresa no responde por el estado de salud
            físico de las personas que viajen en nuestros buses ni tampoco por cualquier trastorno o
            accidente que pudiera sobrevenir, como consecuencia de tal estado.
          </p>

          <p>
            <span class="bold-orange">8.- </span> Serán excluidos del transporte:
          </p>
          <p>
            <span class="bold-blue">{'a)'} </span> las personas que se encuentren bajo la influencia
            del alcohol, de drogas o de otros estupefacientes y de aquellos cuyo estado de salud o
            físico no sea compatible con el viaje.
          </p>
          <p>
            <span class="bold-blue">{'b)'} </span> Portar armas de fuego; sustancias inflamables, o
            cualquier objeto que pueda constituir un peligro para la seguridad del pasajero o la
            carga.
          </p>
          <p>
            <span class="bold-blue">{'c)'} </span> Los objetos que por sus dimensiones u otros
            motivos incomoden al pasajero.
          </p>

          <p>
            <span class="bold-orange">9.- </span> El pasaje solo cubre transporte, todo gasto extra
            será cuenta del pasajero.
          </p>

          <p>
            <span class="bold-orange">10.- </span> El pasajero se compromete y acepta todas las
            disposiciones legales del país, así como portar los documentos y aceptar el control
            policial y aduana, no asumiendo la Empresa ninguna responsabilidad por los actos u
            omisiones en el que el pasajero incurra.
          </p>

          <p>
            <span class="bold-orange">11.- </span> Todo pasaje ida y vuelta está sujeto a espacio, y
            el pasajero debe hacer sus reservaciones con la anticipación debida.
          </p>

          <p>
            <span class="bold-orange">12.- </span> Cualquier característica de seguros por
            accidentes, no especificados en el presente contrato, SE REGIRÁN DE ACUERDO A LAS
            DISPOSICIONES VIGENTES DE CADA PAÍS. En Chile, el Instituto de Seguros del Estado
            (I.S.E.)
          </p>
          <div className="important-terms">
            <span>AVISO IMPORTANTE</span>
          </div>

          <p className='bold-text'>
            <span class="bold-orange">1.- </span> Devolución de Pasajes:
          </p>
          <p>
            No se aceptarán devoluciones de pasajes sin aviso anticipado de 48 horas al día de
            salida, caso contrario perderá su valor total.<br></br>
            Desde las 24 horas anteriores 70%<br></br>
            Desde las 48 horas hasta las 24 horas 80%<br></br>
            Más de 48 horas 90%
          </p>
          <p className='bold-text'>
            <span class="bold-orange">2.- </span> Canje de boleto por cambio de fecha u hora de
            viaje.
          </p>
          <p>
            No se admiten en ningún caso. Solo se aceptará devolución del boleto en las condiciones
            establecidas precedentemente.
          </p>
          <p>
            <span class="bold-orange">3.- </span> Controle en el acto, el boleto, si la fecha, hora
            de viaje, precio abonado y destino están conforme a lo solicitado, después no habrá
            derecho a reclamo.
          </p>
          <p>
            <span class="bold-orange">4.- </span> Los señores pasajeros son responsables directos
            del cuidado de su equipaje y por tanto de los olvidos que puedan producirse en las
            oficinas, Aduanas, ruta de viaje, etc.
          </p>
        </div>
      </div>
    </div>
  ) : null;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeNineRegulationTnCScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeNine/ThemeNinePages/ThemeNineRegulationTnCScreen.js